import { render, staticRenderFns } from "./problemCell.vue?vue&type=template&id=646628cf&scoped=true"
import script from "./problemCell.vue?vue&type=script&lang=js"
export * from "./problemCell.vue?vue&type=script&lang=js"
import style0 from "./problemCell.vue?vue&type=style&index=0&id=646628cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646628cf",
  null
  
)

export default component.exports